import { useContext } from "react";
import { PageContext } from "./PageProvider";
import { PageState } from "./PageProvider.types";

export function usePageState(): PageState {
  const context = useContext(PageContext);

  if (context === undefined) {
    throw new Error("usePageState must be used within a PageProvider");
  }

  return context;
}
